import styled from 'styled-components';

const StyledFileInputPlaceholder = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  input, button {
    pointer-events: none;
  }

  button {
    white-space: nowrap;
    margin-left: 1rem;
  }
`;

export default StyledFileInputPlaceholder;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledFileInputPlaceholder.js